export default __webpack_public_path__ + "static/media/h5-home-banner4.cd5c4180.png";